import "./NotFound.scss"
import notFoundImage from './404.svg'
import {useNavigate} from "react-router-dom";
import {RouteHelper} from "../../route/RouteHelper";
import {RaikoButtonPrimary} from "@moeindal/base-raiko-panel-components";

const NotFound = () => {

    const navigate = useNavigate()

    function handleGoDashboard() {
        navigate(RouteHelper.Dashboard.globalUrl)
    }


    return (
        <div className={"baseNotFoundPageStyle"}>
            <div className={"notFoundItemsContainer"}>
                <img src={notFoundImage} alt=""/>
                <span className={"notFoundTitle"}>صفحه ی مورد نظر شما یافت نشد!</span>
                {/*<span className={"notFoundSubtitle"}>asaas</span>*/}
                <RaikoButtonPrimary label={"صفحـه اصلی"} onClick={handleGoDashboard}/>
            </div>
        </div>
    )
}

export default NotFound